// Plant Storage Utilities for Local Persistence
// This utility handles saving and loading plant data to/from localStorage

const STORAGE_KEY = 'canopy_camera_plants';

// Save plants to localStorage
export const savePlantsToStorage = (plants, snapshotId = 'default') => {
    try {
        const existingData = JSON.parse(localStorage.getItem(STORAGE_KEY) || '{}');
        existingData[snapshotId] = {
            plants,
            lastUpdated: new Date().toISOString()
        };
        localStorage.setItem(STORAGE_KEY, JSON.stringify(existingData));
        return true;
    } catch (error) {
        console.error('Failed to save plants to localStorage:', error);
        return false;
    }
};

// Load plants from localStorage
export const loadPlantsFromStorage = (snapshotId = 'default') => {
    try {
        const data = JSON.parse(localStorage.getItem(STORAGE_KEY) || '{}');
        return data[snapshotId]?.plants || [];
    } catch (error) {
        console.error('Failed to load plants from localStorage:', error);
        return [];
    }
};

// Get all snapshot data from localStorage
export const getAllSnapshotData = () => {
    try {
        return JSON.parse(localStorage.getItem(STORAGE_KEY) || '{}');
    } catch (error) {
        console.error('Failed to load snapshot data from localStorage:', error);
        return {};
    }
};

// Delete plants for a specific snapshot
export const deletePlantsFromStorage = (snapshotId = 'default') => {
    try {
        const data = JSON.parse(localStorage.getItem(STORAGE_KEY) || '{}');
        delete data[snapshotId];
        localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
        return true;
    } catch (error) {
        console.error('Failed to delete plants from localStorage:', error);
        return false;
    }
};

// Clear all plant data from localStorage
export const clearAllPlantStorage = () => {
    try {
        localStorage.removeItem(STORAGE_KEY);
        return true;
    } catch (error) {
        console.error('Failed to clear plant storage:', error);
        return false;
    }
};

// Check if localStorage is available
export const isStorageAvailable = () => {
    try {
        const test = '__storage_test__';
        localStorage.setItem(test, test);
        localStorage.removeItem(test);
        return true;
    } catch {
        return false;
    }
};

// Get storage usage stats
export const getStorageStats = () => {
    try {
        const data = getAllSnapshotData();
        const snapshots = Object.keys(data);
        const totalPlants = snapshots.reduce((sum, key) => sum + (data[key]?.plants?.length || 0), 0);
        
        return {
            totalSnapshots: snapshots.length,
            totalPlants,
            lastUpdated: snapshots.length > 0 ? 
                Math.max(...snapshots.map(key => new Date(data[key]?.lastUpdated || 0).getTime())) : null,
            storageSize: JSON.stringify(data).length
        };
    } catch (error) {
        console.error('Failed to get storage stats:', error);
        return {
            totalSnapshots: 0,
            totalPlants: 0,
            lastUpdated: null,
            storageSize: 0
        };
    }
};

export default {
    savePlantsToStorage,
    loadPlantsFromStorage,
    getAllSnapshotData,
    deletePlantsFromStorage,
    clearAllPlantStorage,
    isStorageAvailable,
    getStorageStats
};
